//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { Component, Inject, OnInit } from '@angular/core';
import { DialogService } from '@app/core/services/dialog-service.service';
import { Helper } from '@rawlings/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
//#endregion Imports
@Component({
  selector: 'app-session-logout-dialog',
  templateUrl: './session-logout-dialog.component.html',
  styleUrls: ['./session-logout-dialog.component.scss']
})
export class SessionLogoutDialogComponent implements OnInit {
    //#region Public Variables
    public BodyMessage: string;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authenticationService: AuthenticationService,
        private dialogService: DialogService
      ) {}

    public ngOnInit(): void {
        this.BodyMessage = !Helper.IsEmpty(this.data?.message) ? this.data?.message : 'Your session has ended due to inactivity.';
    }
    //#endregion Constructor

    //#region Public Methods
    public OnClickRedirectToLogin(): void {
        this.authenticationService.LogoutAndRedirectToLogin();
        this.dialogService.CloseDialog();

    }
    //#endregion Public Methods
}
